import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { useHistory, useParams } from "react-router-dom";

import { HeadingWithBackArrow } from "../../../components/HeadingWithBackArrow";
import { LoaderFallbackUI } from "../../../components/LoaderFallbackUI";
import { hasData } from "../../../utils/commonUtils";
import typography from "../typography";
import { getScheduledNotificationById } from "../../../api/api.service";
import { APP_ROUTES } from "../../../helpers/routeHelpers";
import { notificationDetailsConfig } from "../data";
import { transformApiDataToForm } from "../utils";

export default function ViewNotification() {
    const { id } = useParams();
    const history = useHistory();

    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);
    const [notificationDetails, setNotificationDetails] = useState([]);
    const [error, setError] = useState(null);

    const backButtonHandler = () => {
        history.push(APP_ROUTES.NOTIFICATION_MANAGEMENT);
    };

    useEffect(() => {
        const fetchNotificationDetails = async () => {
            if (!id) {
                setError("Invalid notification ID");
                return;
            }

            try {
                setLoading(true);
                setError(null);
                const response = await getScheduledNotificationById(id);

                if (response) {
                    const transformedData = transformApiDataToForm(response);
                    setData(transformedData);

                    const updatedConfig = notificationDetailsConfig.map(
                        (el) => ({
                            ...el,
                            value: transformedData[el.key] || "-",
                        })
                    );
                    setNotificationDetails(updatedConfig);
                } else {
                    setError("Notification not found");
                }
            } catch (error) {
                console.error("Error fetching notification details:", error);
                setError("Failed to load notification details");
                toast.error("Failed to load notification details");
            } finally {
                setLoading(false);
            }
        };

        fetchNotificationDetails();
    }, [id]);

    const getStatusBadgeClass = (status) => {
        switch (status) {
            case "SENT":
                return "status-sent";
            case "PENDING":
                return "status-pending";
            case "FAILED":
                return "status-failed";
            default:
                return "status-pending";
        }
    };

    if (loading) {
        return <LoaderFallbackUI isLoader={loading} />;
    }

    if (error) {
        return (
            <div className="error-container">
                <HeadingWithBackArrow
                    backArrowClickHandler={backButtonHandler}
                    headingTitle={typography.VIEW_NOTIFICATION}
                    showToggle={false}
                />
                <div className="alert alert-danger m-3">
                    <h5>Error</h5>
                    <p>{error}</p>
                </div>
            </div>
        );
    }

    if (!hasData(data)) {
        return (
            <div className="no-data-container">
                <HeadingWithBackArrow
                    backArrowClickHandler={backButtonHandler}
                    headingTitle={typography.VIEW_NOTIFICATION}
                    showToggle={false}
                />
                <div className="alert alert-info m-3">
                    <h5>No Data</h5>
                    <p>No notification details available.</p>
                </div>
            </div>
        );
    }

    return (
        <>
            <HeadingWithBackArrow
                backArrowClickHandler={backButtonHandler}
                headingTitle={typography.VIEW_NOTIFICATION}
                showToggle={false}
            />
            <div className="notification-details-con">
                <Row className="notification-details-typo p-3">
                    {notificationDetails?.length
                        ? notificationDetails.map((el) => (
                              <Col
                                  key={el.id}
                                  xs="6"
                                  xxl="3"
                                  xl="4"
                                  md="4"
                                  sm="6"
                                  className="mb-5"
                              >
                                  <h6>{el.title}</h6>
                                  {el.id === 4 ? (
                                      // Status badge
                                      <span
                                          className={`notification-status-badge ${getStatusBadgeClass(
                                              el.value
                                          )}`}
                                      >
                                          {el.value}
                                      </span>
                                  ) : (
                                      <p>{el.value}</p>
                                  )}
                              </Col>
                          ))
                        : null}
                </Row>

                <Row className="notification-details-typo p-3">
                    <Col xs="12">
                        <div className="notification-message-section">
                            <h6>Notification Message</h6>
                            <div className="notification-message-content">
                                <p>{data.message}</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
}
